import styled from 'styled-components';
import {tokens} from '@tickchak/react-share/app';
import {dFlexCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const placeholder = styled.div<{expanded?: boolean}>`
    width: 305px;
    flex-shrink: 0;
    height: ${p => p.expanded ? '191px' : '72px'};
    border-radius: var(--space-xs);
    border: 2px dashed var(--TA-color-border-brand);
    background: var(--TA-color-brand-selected);
    ${dFlexCenter};
    color: var(--TA-color-text-default);
    font-size: ${tokens.typography.fontSize.caption};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: 16px;
    pointer-events: none;
    ${mobileMedia} {
        width: 100%;
    }
`;
